module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-BoldItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-BoldItalic.ttf
// module id = 1894
// module chunks = 0